import { motion } from "framer-motion";

export const lineReveal = {
  hidden: { y: "110%" },
  show: (i = 0) => ({
    y: "0%",
    transition: { delay: 0.15 + i * 0.13, duration: 0.9, ease: [0.22, 1, 0.36, 1] },
  }),
};

export function MaskedLine({ children, i = 0, className = "", as = "span" }) {
  const Tag = motion[as] || motion.span;
  return (
    <span className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
      <Tag className={`block ${className}`} variants={lineReveal} initial="hidden" animate="show" custom={i}>
        {children}
      </Tag>
    </span>
  );
}

export function Reveal({ children, delay = 0, y = 28, className = "" }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <p className={`font-mono text-xs sm:text-sm uppercase tracking-[0.25em] text-amberbrand ${className}`}>
      {children}
    </p>
  );
}
